import { useState, useEffect, useCallback } from "react";
import { initTracking, trackPageView } from "./tracking";

const ADMIN_PASSWORD = "magicfeed2026";
const LS_AUTH_KEY = "mfp_admin_auth";
const LS_LEADS_KEY = "magicfeed_leads";
const LS_TRACKING_KEY = "magicfeed_tracking";

const TRACKING_FIELDS = [
  { key: "anthropicApiKey", label: "Anthropic API Key (Claude)", placeholder: "sk-ant-api03-...", group: "api" },
  { key: "metaPixelId", label: "Meta Pixel ID", placeholder: "e.g. 1407795591007394", group: "meta" },
  { key: "metaCapiToken", label: "Meta CAPI Token", placeholder: "EAFqqCSzW704...", group: "meta" },
  { key: "ga4Id", label: "GA4 Measurement ID", placeholder: "e.g. G-XXXXXXXXXX", group: "google" },
  { key: "googleAdsConversionId", label: "Google Ads Conversion ID", placeholder: "e.g. AW-XXXXXXXXX", group: "google" },
  { key: "googleAdsLabelUrlSent", label: "Conv. Label — URL Sent", placeholder: "e.g. AbCdEfGhIjK", group: "google" },
  { key: "googleAdsLabelEmailSent", label: "Conv. Label — Email Sent (Lead)", placeholder: "e.g. XyZaBcDeFgH", group: "google" },
  { key: "googleAdsLabelCtaAudit", label: "Conv. Label — CTA Audit Click", placeholder: "e.g. MnOpQrStUvW", group: "google" },
  { key: "googleAdsLabelCtaFinal", label: "Conv. Label — CTA Final Click", placeholder: "e.g. HiJkLmNoPqR", group: "google" },
  { key: "googleAdsRemarketingId", label: "Google Ads Remarketing Tag ID", placeholder: "e.g. AW-XXXXXXXXX", group: "google" },
  { key: "microsoftUetId", label: "Microsoft Ads UET Tag ID", placeholder: "e.g. 12345678", group: "microsoft" },
  { key: "klaviyoPrivateKey", label: "Klaviyo Private API Key", placeholder: "pk_xxxxxx...", group: "klaviyo" },
  { key: "klaviyoListId", label: "Klaviyo List ID (Feed Audit Leads)", placeholder: "XXXXXX", group: "klaviyo" },
  { key: "telegramBotToken", label: "Telegram Bot Token", placeholder: "e.g. 123456:ABC-DEF...", group: "telegram" },
  { key: "telegramChatId", label: "Telegram Chat ID", placeholder: "e.g. 1217615294", group: "telegram" },
];

function getScoreColor(s) {
  if (s < 40) return "#EF4444";
  if (s < 70) return "#F59E0B";
  return "#10B981";
}

function getScoreBg(s) {
  if (s < 40) return "#FEE2E2";
  if (s < 70) return "#FEF3C7";
  return "#D1FAE5";
}

function MagicFeedLogo() {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "center" }}>
      <svg width="36" height="36" viewBox="0 0 48 48" fill="none">
        <defs>
          <linearGradient id="mfgL" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#6B8BF5"/>
            <stop offset="100%" stopColor="#4B6AE8"/>
          </linearGradient>
        </defs>
        <path d="M18 4L20.5 14L31 16.5L20.5 19L18 29L15.5 19L5 16.5L15.5 14Z" fill="url(#mfgL)"/>
        <path d="M34 6L35.2 10L39 11.2L35.2 12.4L34 16L32.8 12.4L29 11.2L32.8 10Z" fill="url(#mfgL)" opacity="0.7"/>
        <circle cx="40" cy="22" r="2" fill="url(#mfgL)" opacity="0.5"/>
      </svg>
      <span style={{ fontFamily: "'Inter',sans-serif", fontSize: 22, lineHeight: 1, letterSpacing: -0.3 }}>
        <span style={{ fontWeight: 800, color: "#0f172a" }}>Magic</span>
        <span style={{ fontWeight: 400, color: "#0f172a" }}>Feed</span>
        <span style={{ fontSize: 14, fontWeight: 700, color: "#4B6AE8", marginLeft: 2 }}>Pro</span>
      </span>
    </div>
  );
}

function LoginGate({ onAuth }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem(LS_AUTH_KEY, "true");
      onAuth();
    } else {
      setError("Incorrect password");
      setPassword("");
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'Inter',sans-serif",
      background: "linear-gradient(135deg,#f0f4ff 0%,#e8eeff 50%,#dde5ff 100%)",
      padding: 20,
    }}>
      <div style={{
        background: "#fff", borderRadius: 20, padding: "48px 40px", maxWidth: 400, width: "100%",
        textAlign: "center", boxShadow: "0 12px 60px rgba(75,106,232,0.12)",
      }}>
        <div style={{ marginBottom: 28 }}><MagicFeedLogo /></div>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Enter admin password"
            value={password}
            onChange={e => { setPassword(e.target.value); setError(""); }}
            style={{
              width: "100%", background: "#fff", border: "1.5px solid #C7D2FE", borderRadius: 10,
              padding: "12px 14px", color: "#0f172a", fontSize: 14, fontFamily: "'Inter',sans-serif",
              outline: "none", marginBottom: 12, boxSizing: "border-box",
            }}
          />
          {error && <p style={{ fontSize: 12, color: "#EF4444", marginBottom: 10, fontWeight: 500 }}>{error}</p>}
          <button type="submit" style={{
            width: "100%", padding: "12px", background: "linear-gradient(135deg,#4B6AE8,#6B8BF5)",
            border: "none", borderRadius: 10, color: "#fff", fontSize: 14, fontWeight: 600,
            fontFamily: "'Inter',sans-serif", cursor: "pointer",
            boxShadow: "0 4px 16px rgba(75,106,232,0.35)",
          }}>
            → Access Dashboard
          </button>
        </form>
      </div>
    </div>
  );
}

function formatDate(iso) {
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function exportCSV(leads) {
  const header = "date,store_url,email,global_score,title_score,description_score,highlights_score,total_products,utm_source,utm_medium,utm_campaign,utm_content,utm_term";
  const rows = leads.map(l =>
    `${l.timestamp},${l.storeUrl},${l.email},${l.globalScore},${l.titleScore},${l.descriptionScore},${l.highlightsScore},${l.totalProducts || 0},${l.utm_source || ""},${l.utm_medium || ""},${l.utm_campaign || ""},${l.utm_content || ""},${l.utm_term || ""}`
  );
  const csv = [header, ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "leads.csv";
  a.click();
  URL.revokeObjectURL(url);
}

function TrackingConfig() {
  const [config, setConfig] = useState(() => {
    try { return JSON.parse(localStorage.getItem(LS_TRACKING_KEY) || "{}"); } catch { return {}; }
  });
  const [saved, setSaved] = useState(false);
  const [testStatus, setTestStatus] = useState(""); // "" | "firing" | "success" | "error"
  const [testLog, setTestLog] = useState([]);

  // Load from API on mount
  useEffect(() => {
    fetch("/api/data?key=tracking")
      .then(r => r.ok ? r.json() : null)
      .then(json => {
        if (json && json.data) {
          let cfg = json.data;
          // Handle string data (legacy double-stringify)
          if (typeof cfg === "string") {
            try { cfg = JSON.parse(cfg); } catch { cfg = {}; }
          }
          // Clean corrupted data (numeric keys from string spread bug)
          if (cfg && typeof cfg === "object" && !Array.isArray(cfg)) {
            const cleaned = {};
            for (const [k, v] of Object.entries(cfg)) {
              if (!/^\d+$/.test(k)) cleaned[k] = v;
            }
            cfg = cleaned;
          }
          if (Object.keys(cfg).length > 0) {
            setConfig(cfg);
            localStorage.setItem(LS_TRACKING_KEY, JSON.stringify(cfg));
            try { initTracking(); } catch {}
          }
        }
      })
      .catch(() => {});
  }, []);

  const handleChange = (key, value) => {
    setConfig(prev => ({ ...prev, [key]: value }));
    setSaved(false);
  };

  const handleSave = () => {
    localStorage.setItem(LS_TRACKING_KEY, JSON.stringify(config));
    // Persist to server
    fetch("/api/data", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ key: "tracking", value: config }),
    }).catch(() => {});
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
    try { initTracking(); } catch {}
  };

  const handleFireTestEvents = async () => {
    // Save config first
    localStorage.setItem(LS_TRACKING_KEY, JSON.stringify(config));
    try { initTracking(); } catch {}

    setTestStatus("firing");
    const log = [];

    // 1. Fire Meta Pixel events (client-side)
    if (config.metaPixelId && window.fbq) {
      try {
        window.fbq("track", "PageView", { page: "test" });
        window.fbq("trackCustom", "AuditUrlSent", { store_url: "test-store.com" });
        window.fbq("trackCustom", "EmailSent", { content_name: "audit_email", value: 50, store_url: "test-store.com" });
        window.fbq("trackCustom", "CtaAuditClick", { store_url: "test-store.com" });
        window.fbq("trackCustom", "CtaFinalClick");
        log.push({ platform: "Meta Pixel", status: "ok", msg: "5 events fired (PageView, AuditUrlSent, EmailSent, CtaAuditClick, CtaFinalClick)" });
      } catch (err) {
        log.push({ platform: "Meta Pixel", status: "error", msg: err.message });
      }
    } else if (config.metaPixelId) {
      log.push({ platform: "Meta Pixel", status: "error", msg: "fbq not loaded — save config and refresh page" });
    }

    // 2. Fire Meta CAPI events (server-side) — all 5 events
    if (config.metaPixelId && config.metaCapiToken) {
      const capiEvents = [
        { event_name: "PageView", email: null, store_url: null, score: null },
        { event_name: "AuditUrlSent", email: null, store_url: "test-store.com", score: null },
        { event_name: "EmailSent", email: "test@magicfeedpro.com", store_url: "test-store.com", score: 50 },
        { event_name: "CtaAuditClick", email: null, store_url: "test-store.com", score: null },
        { event_name: "CtaFinalClick", email: null, store_url: null, score: null },
      ];
      let capiOk = 0;
      let capiErr = null;
      for (const evt of capiEvents) {
        try {
          const capiRes = await fetch("/api/capi", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ...evt,
              pixel_id: config.metaPixelId,
              capi_token: config.metaCapiToken,
              event_source_url: window.location.href,
              user_agent: navigator.userAgent,
            }),
          });
          if (capiRes.ok) { capiOk++; }
          else {
            const d = await capiRes.json();
            capiErr = JSON.stringify(d.error || d);
          }
        } catch (err) { capiErr = err.message; }
      }
      if (capiOk > 0) {
        log.push({ platform: "Meta CAPI", status: capiOk === 5 ? "ok" : "warn", msg: `${capiOk}/5 server events sent (PageView, AuditUrlSent, EmailSent, CtaAuditClick, CtaFinalClick)${capiErr ? ` — last error: ${capiErr}` : ""}` });
      } else {
        log.push({ platform: "Meta CAPI", status: "error", msg: capiErr || "All events failed" });
      }
    }

    // 3. Fire GA4 events
    if (config.ga4Id && window.gtag) {
      try {
        window.gtag("event", "page_view", { page_title: "test" });
        window.gtag("event", "audit_url_sent", { store_url: "test-store.com" });
        window.gtag("event", "generate_lead", { currency: "USD", value: 0 });
        log.push({ platform: "GA4", status: "ok", msg: "3 events fired (page_view, audit_url_sent, generate_lead)" });
      } catch (err) {
        log.push({ platform: "GA4", status: "error", msg: err.message });
      }
    } else if (config.ga4Id) {
      log.push({ platform: "GA4", status: "error", msg: "gtag not loaded — save config and refresh page" });
    }

    // 4. Fire Google Ads conversions (one per label)
    if (config.googleAdsConversionId && window.gtag) {
      try {
        const labels = [
          { key: "googleAdsLabelUrlSent", name: "URL Sent", value: 0 },
          { key: "googleAdsLabelEmailSent", name: "Email Sent", value: 1 },
          { key: "googleAdsLabelCtaAudit", name: "CTA Audit", value: 5 },
          { key: "googleAdsLabelCtaFinal", name: "CTA Final", value: 10 },
        ];
        const fired = [];
        labels.forEach(l => {
          if (config[l.key]) {
            window.gtag("event", "conversion", {
              send_to: `${config.googleAdsConversionId}/${config[l.key]}`,
              value: l.value, currency: "USD",
            });
            fired.push(l.name);
          }
        });
        if (fired.length > 0) {
          log.push({ platform: "Google Ads", status: "ok", msg: `${fired.length} conversions fired: ${fired.join(", ")}` });
        } else {
          log.push({ platform: "Google Ads", status: "error", msg: "Conversion ID set but no labels configured" });
        }
      } catch (err) {
        log.push({ platform: "Google Ads", status: "error", msg: err.message });
      }
    }

    // 5. Fire Microsoft UET events
    if (config.microsoftUetId && window.uetq) {
      try {
        window.uetq.push("event", "page_view", { page_path: "test" });
        window.uetq.push("event", "lead", { event_category: "conversion" });
        log.push({ platform: "Microsoft UET", status: "ok", msg: "2 events fired (page_view, lead)" });
      } catch (err) {
        log.push({ platform: "Microsoft UET", status: "error", msg: err.message });
      }
    } else if (config.microsoftUetId) {
      log.push({ platform: "Microsoft UET", status: "error", msg: "uetq not loaded — save config and refresh page" });
    }

    // 6. Fire Klaviyo test
    if (config.klaviyoPrivateKey && config.klaviyoListId) {
      try {
        const klavRes = await fetch("/api/klaviyo", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: "test@magicfeedpro.com",
            storeUrl: "test-store.com",
            globalScore: 50,
            titleScore: 40,
            descriptionScore: 30,
            highlightsScore: 20,
            totalProducts: 100,
            klaviyoPrivateKey: config.klaviyoPrivateKey,
            klaviyoListId: config.klaviyoListId,
          }),
        });
        const klavData = await klavRes.json();
        if (klavRes.ok) {
          log.push({ platform: "Klaviyo", status: "ok", msg: `Profile synced — ID: ${klavData.profileId || "ok"}` });
        } else {
          log.push({ platform: "Klaviyo", status: "error", msg: JSON.stringify(klavData.error || klavData) });
        }
      } catch (err) {
        log.push({ platform: "Klaviyo", status: "error", msg: err.message });
      }
    }

    if (log.length === 0) {
      log.push({ platform: "None", status: "error", msg: "No platforms configured. Fill in at least one pixel/tag ID above." });
    }

    setTestLog(log);
    setTestStatus(log.every(l => l.status === "ok") ? "success" : "error");
  };

  return (
    <div style={{
      background: "#fff", borderRadius: 16, border: "1px solid #E5E7EB",
      boxShadow: "0 1px 4px rgba(0,0,0,0.04)", marginBottom: 28, overflow: "hidden",
    }}>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "16px 20px", borderBottom: "1px solid #F3F4F6",
      }}>
        <span style={{ fontSize: 15, fontWeight: 700, color: "#0f172a" }}>Tracking & Integrations</span>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={handleFireTestEvents} disabled={testStatus === "firing"} style={{
            background: testStatus === "firing" ? "#F3F4F6" : "#FEF3C7",
            border: "1.5px solid #FDE68A", borderRadius: 8,
            padding: "7px 14px", fontSize: 12, fontWeight: 600,
            color: "#92400E",
            cursor: testStatus === "firing" ? "wait" : "pointer",
            fontFamily: "'Inter',sans-serif",
          }}>
            {testStatus === "firing" ? "Firing..." : "🔥 Fire Test Events"}
          </button>
          <button onClick={handleSave} style={{
            background: saved ? "#D1FAE5" : "linear-gradient(135deg,#4B6AE8,#6B8BF5)",
            border: saved ? "1.5px solid #6EE7B7" : "none", borderRadius: 8,
            padding: "7px 16px", fontSize: 12, fontWeight: 600,
            color: saved ? "#059669" : "#fff",
            cursor: "pointer", fontFamily: "'Inter',sans-serif",
            transition: "all 0.2s ease",
          }}>
            {saved ? "✓ Saved!" : "Save Config"}
          </button>
        </div>
      </div>
      <div style={{ padding: "16px 20px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {TRACKING_FIELDS.map(field => (
            <div key={field.key}>
              <label style={{ fontSize: 11, fontWeight: 600, color: "#6B7280", display: "block", marginBottom: 4 }}>
                {field.label}
              </label>
              <input
                type="text"
                placeholder={field.placeholder}
                value={config[field.key] || ""}
                onChange={e => handleChange(field.key, e.target.value)}
                style={{
                  width: "100%", background: "#F9FAFB", border: "1.5px solid #E5E7EB", borderRadius: 8,
                  padding: "8px 10px", color: "#0f172a", fontSize: 12, fontFamily: "'Inter',sans-serif",
                  outline: "none", boxSizing: "border-box",
                  transition: "border-color 0.2s",
                }}
                onFocus={e => e.target.style.borderColor = "#4361EE"}
                onBlur={e => e.target.style.borderColor = "#E5E7EB"}
              />
            </div>
          ))}
        </div>
        <p style={{ fontSize: 11, color: "#94a3b8", marginTop: 12 }}>
          Paste your pixel/tag IDs here. Leave empty to skip a platform. Changes apply after saving.<br/>
          Klaviyo: Find keys in Klaviyo → Account → Settings → API Keys, and Lists → your list ID.
        </p>

        {/* Test results log */}
        {testLog.length > 0 && (
          <div style={{
            marginTop: 16, background: "#F9FAFB", borderRadius: 10,
            border: "1px solid #E5E7EB", padding: "12px 14px",
          }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#0f172a", marginBottom: 10 }}>
              Test Results
            </div>
            {testLog.map((entry, i) => (
              <div key={i} style={{
                display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 6,
                fontSize: 12, lineHeight: 1.4,
              }}>
                <span style={{
                  flexShrink: 0, fontSize: 11, fontWeight: 700,
                  color: entry.status === "ok" ? "#059669" : "#EF4444",
                }}>
                  {entry.status === "ok" ? "✓" : "✗"}
                </span>
                <span style={{ fontWeight: 600, color: "#374151", minWidth: 90 }}>{entry.platform}</span>
                <span style={{ color: entry.status === "ok" ? "#059669" : "#EF4444" }}>{entry.msg}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function AdminPage() {
  const [authed, setAuthed] = useState(() => localStorage.getItem(LS_AUTH_KEY) === "true");
  const [leads, setLeads] = useState([]);

  const loadLeads = useCallback(async () => {
    let data = [];
    try {
      const res = await fetch("/api/data?key=leads");
      if (res.ok) {
        const json = await res.json();
        if (Array.isArray(json.data) && json.data.length > 0) {
          data = json.data;
          localStorage.setItem(LS_LEADS_KEY, JSON.stringify(data));
        }
      }
    } catch {}
    // Fallback to localStorage
    if (data.length === 0) {
      try { data = JSON.parse(localStorage.getItem(LS_LEADS_KEY) || "[]"); } catch {}
    }
    data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    setLeads(data);
  }, []);

  useEffect(() => {
    if (!authed) return;
    loadLeads();
    initTracking();
    trackPageView("admin");
    const interval = setInterval(loadLeads, 30000);
    return () => clearInterval(interval);
  }, [authed, loadLeads]);

  const handleLogout = () => {
    localStorage.removeItem(LS_AUTH_KEY);
    setAuthed(false);
  };

  const handleDelete = (index) => {
    const sorted = [...leads];
    sorted.splice(index, 1);
    setLeads(sorted);
    localStorage.setItem(LS_LEADS_KEY, JSON.stringify(sorted));
    fetch("/api/data", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ key: "leads", value: sorted }),
    }).catch(() => {});
  };

  if (!authed) return <LoginGate onAuth={() => setAuthed(true)} />;

  // KPIs
  const totalLeads = leads.length;
  const today = new Date().toDateString();
  const auditsToday = leads.filter(l => new Date(l.timestamp).toDateString() === today).length;
  const avgScore = totalLeads > 0
    ? Math.round(leads.reduce((s, l) => s + (l.globalScore || 0), 0) / totalLeads)
    : 0;
  const leadsWithEmail = leads.filter(l => l.email).length;
  const conversionRate = totalLeads > 0 ? Math.round((leadsWithEmail / totalLeads) * 100) : 0;

  // Score distribution
  const critical = leads.filter(l => (l.globalScore || 0) <= 40).length;
  const warning = leads.filter(l => (l.globalScore || 0) > 40 && (l.globalScore || 0) <= 70).length;
  const good = leads.filter(l => (l.globalScore || 0) > 70).length;
  const maxBar = Math.max(critical, warning, good, 1);

  const cardStyle = {
    flex: 1, background: "#fff", borderRadius: 14, padding: "20px 16px",
    border: "1px solid #E5E7EB", textAlign: "center",
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)", minWidth: 0,
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        html, body, #root { height:100%; overflow:auto; }
        @media (max-width: 768px) {
          .admin-kpi-row { flex-direction: column !important; }
          .admin-table-wrap { overflow-x: auto !important; }
          .admin-table { min-width: 700px !important; }
        }
      `}</style>

      <div style={{
        minHeight: "100vh", fontFamily: "'Inter',sans-serif",
        background: "linear-gradient(135deg,#f0f4ff 0%,#e8eeff 50%,#dde5ff 100%)",
        padding: "32px 20px",
      }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>

          {/* ── HEADER ── */}
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            marginBottom: 28,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18, fontWeight: 800, color: "#0f172a" }}>
                ✦ MagicFeedPro Admin
              </span>
            </div>
            <button onClick={handleLogout} style={{
              background: "#fff", border: "1.5px solid #E5E7EB", borderRadius: 8,
              padding: "8px 16px", fontSize: 13, fontWeight: 600, color: "#6B7280",
              cursor: "pointer", fontFamily: "'Inter',sans-serif",
            }}>
              Logout
            </button>
          </div>

          {/* ── SECTION 1: KPI CARDS ── */}
          <div className="admin-kpi-row" style={{ display: "flex", gap: 12, marginBottom: 28 }}>
            <div style={cardStyle}>
              <div style={{ fontSize: 11, color: "#6B7280", fontWeight: 500, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>Total Leads</div>
              <div style={{ fontSize: 32, fontWeight: 800, color: "#0f172a" }}>{totalLeads}</div>
            </div>
            <div style={cardStyle}>
              <div style={{ fontSize: 11, color: "#6B7280", fontWeight: 500, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>Audits Today</div>
              <div style={{ fontSize: 32, fontWeight: 800, color: "#4361EE" }}>{auditsToday}</div>
            </div>
            <div style={cardStyle}>
              <div style={{ fontSize: 11, color: "#6B7280", fontWeight: 500, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>Avg Feed Score</div>
              <div style={{ fontSize: 32, fontWeight: 800, color: getScoreColor(avgScore) }}>{avgScore}<span style={{ fontSize: 16, fontWeight: 500, color: "#94a3b8" }}>/100</span></div>
            </div>
            <div style={cardStyle}>
              <div style={{ fontSize: 11, color: "#6B7280", fontWeight: 500, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>URL → Email Rate</div>
              <div style={{ fontSize: 32, fontWeight: 800, color: "#0f172a" }}>{conversionRate}<span style={{ fontSize: 16, fontWeight: 500, color: "#94a3b8" }}>%</span></div>
            </div>
          </div>

          {/* ── SECTION 2: LEADS TABLE ── */}
          <div style={{
            background: "#fff", borderRadius: 16, border: "1px solid #E5E7EB",
            boxShadow: "0 1px 4px rgba(0,0,0,0.04)", marginBottom: 28, overflow: "hidden",
          }}>
            {/* Table header bar */}
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "16px 20px", borderBottom: "1px solid #F3F4F6",
            }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: "#0f172a" }}>Captured Leads</span>
              {leads.length > 0 && (
                <button onClick={() => exportCSV(leads)} style={{
                  background: "#F3F4F6", border: "1.5px solid #E5E7EB", borderRadius: 8,
                  padding: "7px 14px", fontSize: 12, fontWeight: 600, color: "#374151",
                  cursor: "pointer", fontFamily: "'Inter',sans-serif",
                  display: "flex", alignItems: "center", gap: 6,
                }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                  Export CSV
                </button>
              )}
            </div>

            {leads.length === 0 ? (
              <div style={{ padding: "48px 20px", textAlign: "center" }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>📭</div>
                <div style={{ fontSize: 14, color: "#6B7280", lineHeight: 1.6 }}>
                  No leads yet.<br />Share your audit page to start capturing leads.
                </div>
              </div>
            ) : (
              <div className="admin-table-wrap" style={{ overflowX: "auto" }}>
                <table className="admin-table" style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: "#F9FAFB" }}>
                      {["Date", "Store URL", "Email", "Score", "Title", "Desc", "HL", "Source", "Medium", "Campaign", "Content", "Term", "Audit", ""].map((h, i) => (
                        <th key={i} style={{
                          padding: "10px 12px", textAlign: "left", fontSize: 11,
                          fontWeight: 700, color: "#6B7280", textTransform: "uppercase",
                          letterSpacing: 0.5, borderBottom: "1px solid #F3F4F6",
                          whiteSpace: "nowrap",
                        }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {leads.map((lead, i) => (
                      <tr key={i} style={{ borderBottom: "1px solid #F3F4F6" }}>
                        <td style={{ padding: "10px 12px", whiteSpace: "nowrap", color: "#6B7280" }}>
                          {formatDate(lead.timestamp)}
                        </td>
                        <td style={{ padding: "10px 12px" }}>
                          <a href={`https://${lead.storeUrl}`} target="_blank" rel="noreferrer"
                            style={{ color: "#4361EE", textDecoration: "none", fontWeight: 500 }}>
                            {lead.storeUrl}
                          </a>
                        </td>
                        <td style={{ padding: "10px 12px" }}>
                          <a href={`mailto:${lead.email}`} style={{ color: "#374151", textDecoration: "none" }}>
                            {lead.email}
                          </a>
                        </td>
                        <td style={{ padding: "10px 12px" }}>
                          <span style={{
                            background: getScoreBg(lead.globalScore), color: getScoreColor(lead.globalScore),
                            padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700, whiteSpace: "nowrap",
                          }}>{lead.globalScore}/100</span>
                        </td>
                        <td style={{ padding: "10px 12px", color: getScoreColor(lead.titleScore), fontWeight: 700 }}>
                          {lead.titleScore}
                        </td>
                        <td style={{ padding: "10px 12px", color: getScoreColor(lead.descriptionScore), fontWeight: 700 }}>
                          {lead.descriptionScore}
                        </td>
                        <td style={{ padding: "10px 12px", color: getScoreColor(lead.highlightsScore), fontWeight: 700 }}>
                          {lead.highlightsScore}
                        </td>
                        {[lead.utm_source, lead.utm_medium, lead.utm_campaign, lead.utm_content, lead.utm_term].map((val, ui) => (
                          <td key={`utm-${ui}`} style={{ padding: "10px 12px", fontSize: 11, color: val ? "#374151" : "#D1D5DB", whiteSpace: "nowrap", maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis" }}>
                            {val || "—"}
                          </td>
                        ))}
                        <td style={{ padding: "10px 12px" }}>
                          {lead.auditData ? (
                            <button
                              onClick={() => {
                                const auditId = "mfp_audit_" + Date.now();
                                localStorage.setItem(auditId, JSON.stringify(lead.auditData));
                                window.open(`/audit?id=${auditId}`, "_blank");
                              }}
                              style={{
                                background: "none", border: "none", cursor: "pointer",
                                color: "#4361EE", fontSize: 12, fontWeight: 600,
                                fontFamily: "'Inter',sans-serif", padding: "4px 8px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              📊 View
                            </button>
                          ) : (
                            <span style={{ color: "#D1D5DB", fontSize: 12 }}>—</span>
                          )}
                        </td>
                        <td style={{ padding: "10px 12px" }}>
                          <button onClick={() => handleDelete(i)} style={{
                            background: "none", border: "none", cursor: "pointer",
                            fontSize: 12, color: "#EF4444", fontWeight: 600,
                            fontFamily: "'Inter',sans-serif", padding: "4px 8px",
                            borderRadius: 6, whiteSpace: "nowrap",
                          }}
                            onMouseEnter={e => e.currentTarget.style.background = "#FEE2E2"}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}
                          >
                            🗑 Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* ── SECTION 3: SCORE DISTRIBUTION ── */}
          <div style={{
            background: "#fff", borderRadius: 16, border: "1px solid #E5E7EB",
            boxShadow: "0 1px 4px rgba(0,0,0,0.04)", padding: "20px 24px",
          }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#0f172a", marginBottom: 16 }}>Score Distribution</div>
            {[
              { label: "Critical (0–40)", count: critical, color: "#EF4444", bg: "#FEE2E2", emoji: "🔴" },
              { label: "Warning (41–70)", count: warning, color: "#F59E0B", bg: "#FEF3C7", emoji: "🟡" },
              { label: "Good (71–100)", count: good, color: "#10B981", bg: "#D1FAE5", emoji: "🟢" },
            ].map((bar, i) => (
              <div key={i} style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                  <span style={{ fontSize: 13, color: "#374151", fontWeight: 500 }}>
                    {bar.emoji} {bar.label}
                  </span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: bar.color }}>{bar.count} lead{bar.count !== 1 ? "s" : ""}</span>
                </div>
                <div style={{ height: 10, background: "#F3F4F6", borderRadius: 999, overflow: "hidden" }}>
                  <div style={{
                    height: "100%", borderRadius: 999, background: bar.color,
                    width: `${(bar.count / maxBar) * 100}%`,
                    transition: "width 0.3s ease",
                  }}/>
                </div>
              </div>
            ))}
            {totalLeads === 0 && (
              <div style={{ fontSize: 13, color: "#94a3b8", textAlign: "center", padding: "12px 0" }}>
                No data yet.
              </div>
            )}
          </div>

          {/* ── SECTION 4: TRACKING CONFIG ── */}
          <div style={{ marginTop: 28 }}>
            <TrackingConfig />
          </div>

        </div>{/* end max-w container */}
      </div>
    </>
  );
}
